import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import IvergramaTitle from '../../Ivergrama/common/IvergramaTitle';
import KuposHelmet from '../../../common/KuposHelmet';
import React from 'react';
import ThemeFourTitle from '../common/ThemeFourTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeFourTnCScreen = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;

	const createMarkup = data => {
		return { __html: data };
	};

	return (
		<div>
			<KuposHelmet />

			<HeroSection
				title={'Términos y condiciones'}
				height={'43vh'}
				marginTop="-18px"
				description={'Home / Términos y condiciones'}
				heroImage={getIcons('tncBanner', operator)}
			/>
			<div className="new-container" style={{ marginTop: 20 }}>
				<ThemeFourTitle title="Condiciones de compra por internet" />


			</div>

			<div className="new-container mb10 mt10">
				{operator && operator.operator_name === 'losnavegadores' ? (<div
					dangerouslySetInnerHTML={createMarkup(operator.terms ? operator.terms : '')}
					className="lh-1-3 terms-and-conditions font11 scroll"
					style={{ fontSize: '13px', textAlign: 'justify' }}
				/>) : (<div
					dangerouslySetInnerHTML={createMarkup(operator.terms ? operator.terms : '')}
					className="lh-1-3 terms-and-conditions font11 "
					style={{ fontSize: '13px', textAlign: 'justify' }}
				/>)}

			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFourTnCScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/ThemeFourPages/ThemeFourTnCScreen.js